/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/home",
    name: "DASHBOARD",
    slug: "dashboard",
    icon: "HomeIcon",
  },
  {
    url: "",
    name: "CADASTROS",
    slug: "cadastros",
    icon: "BookIcon",
    submenu: [
      {
        url: '/cadastro/empresas/pesquisar',
        name: "Empresas",
        slug: "menu-cadastro-empresas",
      },
      {
        url: '/cadastro/instituicoes/pesquisar',
        name: "Instituições",
        slug: "menu-cadastro-instituicoes",
      },
      {
        url: '/cadastro/favorecidos/pesquisar',
        name: "Favorecidos",
        slug: "menu-cadastro-favorecidos",
      },
      {
        url: '/cadastro/categorias-produtos/pesquisar',
        name: "Categoria Produtos",
        slug: "menu-cadastro-categorias-produtos",
      },
      {
        url: '/cadastro/grupos-contas/pesquisar',
        name: "Grupo Contas",
        slug: "menu-cadastro-grupos-contas",
      },
      {
        url: '/cadastro/produtos/pesquisar',
        name: "Produtos",
        slug: "menu-cadastro-produtos",
      },     
      {
        url: '/cadastro/contas/pesquisar',
        name: "Contas",
        slug: "menu-cadastro-contas",
      },
      {
        url: '/cadastro/usuarios/pesquisar',
        name: "Usuários",
        slug: "menu-cadastro-usuarios",
      },
      
    ]
  },
  {    
    url: "",
    name: "FINANCEIRO",
    slug: "financeiro",
    icon: "DivideIcon",
    submenu: [
      {
        url: '/financeiro/conta-recorrente/pesquisar',
        name: "Conta Recorrente",
        slug: "menu-financeiro-conta-recorrente",
      },  
      {
        url: '/financeiro/contas-a-pagar/pesquisar',
        name: "Contas à Pagar",        
        slug: "menu-financeiro-contas-a-pagar",
      },  
      {
        url: '/financeiro/contas-a-receber/pesquisar',
        name: "Contas à Receber",        
        slug: "menu-financeiro-contas-a-receber",
      },  
      {
        url: '/financeiro/item-conta-futuro/pesquisar',
        name: "Itens Futuro",
        slug: "menu-financeiro-item-conta-futuro",
      },      
      {
        url: '/financeiro/compras/pesquisar',
        name: "Compras",
        slug: "menu-financeiro-compras",
      },
      {
        url: '/financeiro/remessa/pesquisar',
        name: "Remessa",
        slug: "menu-financeiro-remessa",
      },
      {
        url: '/financeiro/retorno/processar',
        name: "Retorno",
        slug: "menu-financeiro-retorno",
      }                     
    ]
  },
  {
    url: '/relatorios',
    name: "RELATÓRIOS",        
    icon: "PrinterIcon",
    slug: "menu-relatorios",
    i18n: "Relatorios"
  },

]
